export class AzureManagementGroups {
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "tenants",
            "baseName": "tenants",
            "type": "Array<AzureTenant>",
            "format": ""
        },
        {
            "name": "managementGroups",
            "baseName": "managementGroups",
            "type": "Array<AzureManagementGroup>",
            "format": ""
        }
    ];
    static getAttributeTypeMap() {
        return AzureManagementGroups.attributeTypeMap;
    }
    constructor() {
    }
}
